import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalTitle,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@apollo/orbit';
import React from 'react';

import { HotkeyDictionaryItem } from 'src/hooks/useKeypressListener/hotkeyDictionary';
import { MonacoHotkeyDictionaryItem } from 'src/hooks/useKeypressListener/monacoHotkeyDictionary';

export const KeyboardShortcutModal = ({
  onClose,
  shortcuts,
}: {
  onClose: () => void;
  shortcuts: Record<string, HotkeyDictionaryItem | MonacoHotkeyDictionaryItem>;
}) => {
  return (
    <Modal size="xl" isOpen={true} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <ModalTitle>Keyboard shortcuts</ModalTitle>
        </ModalHeader>
        <ModalBody>
          <TableContainer className="overflow-y-auto">
            <Table size="condensed" className="table-fixed">
              <Thead>
                <Tr>
                  <Th>Action</Th>
                  <Th className="text-end">Shortcut</Th>
                </Tr>
              </Thead>
              <Tbody>
                {Object.values(shortcuts).map(({ actionName, label }) => (
                  <Tr key={actionName}>
                    <Td>{actionName}</Td>
                    <Td className="text-end">{label}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        </ModalBody>
        <ModalFooter>
          <Button variant="primary" onClick={onClose}>
            Done
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
